import React, { PropsWithChildren } from "react";
import { ReactComponent as ApolloMark } from "@apollo/brand/logos/symbol.svg";
import { Box, HStack, Link, StackProps, chakra } from "@chakra-ui/react";
import { Link as GatsbyLink } from "gatsby";

type LogoTitleProps = PropsWithChildren<StackProps> & {
  hasBreadcrumb?: boolean;
};

export const LogoTitle = ({
  children = "Odyssey",
  hasBreadcrumb,
  ...props
}: LogoTitleProps) => (
  <HStack spacing="2.5" minW="75%" pr="44px" {...props}>
    <Box fill={"current"} w="7" h="8" flexShrink={0} as={ApolloMark} />
    <chakra.span textStyle="smallCaps" fontSize="lg" isTruncated>
      {hasBreadcrumb ? (
        <>
          <Link as={GatsbyLink} to="/">
            Odyssey
          </Link>{" "}
          <span>/ {children}</span>
        </>
      ) : (
        children
      )}
    </chakra.span>
  </HStack>
);
